import BaseComponent from './BaseComponent';

class Search extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.urlParams = new URLSearchParams(window.location.search);
        this.handlePagination();
        this.handleRestrictedLink();
        this.handleCheckboxes(el, 'neos_type');
        this.handleSearch(el);
    }

    handleSearch(el) {
        document.body.addEventListener('submit', (e) => {
            if (!e.target.closest('.hero-secondary__body__search__form')) {
                return;
            }
            e.preventDefault();
            this.urlParams.set('offset', '0');
            this.urlParams.set('search', this.el.querySelector('#search').value);
            fetch(`?${this.urlParams}`)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    el.querySelector('.search-container').innerHTML = div.querySelector('.search-container').innerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }

    handleCheckboxes(el, selector) {
        let checkboxes = this.el.querySelectorAll(`#${selector} input`);
        checkboxes.forEach((checkbox) => {
            document.body.addEventListener('change', (e) => {
                if (checkbox.value !== e.target.value) {
                    return;
                }
                this.urlParams.set('offset', '0');
                let jsonValues = JSON.parse(e.target.value);
                if (e.target.checked) {
                    jsonValues.forEach((t) => {
                        this.urlParams.append(`${selector}[]`, t);
                    });
                } else {
                    let dioceses = this.urlParams.getAll(`${selector}[]`);
                    this.urlParams.delete(`${selector}[]`);
                    dioceses.forEach((d) => {
                        if (jsonValues.indexOf(d) > -1) {
                            return;
                        }
                        this.urlParams.append(`${selector}[]`, d);
                    });
                }
                fetch(`?${this.urlParams}`)
                    .then(function (response) {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then(function (html) {
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        el.querySelector('.search-container').innerHTML =
                            div.querySelector('.search-container').innerHTML;
                    })
                    .catch(function (error) {
                        console.warn(error);
                    });
            });
        });
    }

    handlePagination() {
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('.search-result-list__button')) {
                return;
            }
            e.preventDefault();
            e.target.classList.add('is-active');
            this.urlParams.set('offset', e.target.dataset.offset);
            fetch(`?${this.urlParams}`)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    e.target.outerHTML = div.querySelector('.search-result-list').innerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }

    handleRestrictedLink() {
        document.body.addEventListener('click', (e) => {
            const systemEl = e.target.closest('.system');
            if (!systemEl) {
                return;
            }

            if (systemEl.dataset.lock == 1) {
                e.preventDefault();
                window.location.hash = 'restricted-link';
                document.getElementById('restricted-link-button').href = systemEl.href;
            }
        });
    }
}

export default Search;
